import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpotWeldingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Spot welding" }),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M44.5 70v17.5c0 4.1 11 4.1 11 0V70Z",
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.5 86.5c0 4.1 11 4.1 11 0",
			fill: "none",
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "m27 55 35-20.2L91 51.5v3.8L56 75.5 27 58.8Z",
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m27 55 29 16.7 35-20.2M56 71.7v3.8",
			fill: "none",
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "m9 47.8 35-20.2 29 16.7v3.8L38 68.3 9 51.6Z",
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m9 47.8 29 16.7 35-20.2M38 64.5v3.8",
			fill: "none",
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 50,
			cy: 48.7,
			rx: 7.4,
			ry: 4.3,
			fill: "none",
			stroke: "var(--icon-highlight)",
			strokeWidth: 2.4
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M44.5 10.5v23l3 5.2v8.6c0 1.9 5 1.9 5 0v-8.6l3-5.2v-23Z",
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "icon-white",
			cx: 50,
			cy: 10.5,
			rx: 5.5,
			ry: 2.1,
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.5 44.8v2.5c0 1.9 5 1.9 5 0v-2.5M47.5 74.6v-2.3M52.5 74.6v-2.3",
			fill: "none",
			stroke: "var(--icon-highlight)",
			strokeWidth: 2.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m37.5 44.3-3.8-2.2m28.8 13.6 3.8 2.2M62.5 44.3l3.8-2.2M37.5 55.7l-3.8 2.2",
			fill: "none",
			stroke: "var(--icon-highlight)",
			strokeWidth: 2.4,
			strokeLinecap: "round"
		})
	]
});
export default SvgSpotWeldingSm;
